import {
  SHOW_SUBSCRIBE_AS_EDUCATOR_MODAL,
  TRIAL_COUNTDOWN_BANNER_CLICK,
  CLOSE_SUBSCRIBE_AS_EDUCATOR_MODAL,
  SOLUTIONS_SITE_LINK_CLICK,
  UPGRADE_EDUCATOR_TRIAL_SUBSCRIPTION_CLICK,
} from './actions';
import { canDismissSubscribeAsEducatorModalSelector } from './selectors';

export function showSubscribeAsEducatorModal() {
  return {
    type: SHOW_SUBSCRIBE_AS_EDUCATOR_MODAL,
  };
}

export function trialCountDownBannerClick() {
  return {
    type: TRIAL_COUNTDOWN_BANNER_CLICK,
  };
}

export function upgradeEducatorSubscriptionClick() {
  return {
    type: UPGRADE_EDUCATOR_TRIAL_SUBSCRIPTION_CLICK,
  };
}

export function closeSubscribeAsEducatorModal() {
  return (dispatch, getState) => {
    const canDismiss = canDismissSubscribeAsEducatorModalSelector(getState());
    if (canDismiss) {
      dispatch({
        type: CLOSE_SUBSCRIBE_AS_EDUCATOR_MODAL,
      });
    }
  };
}

export function solutionsSiteLinkClick(eventData) {
  return {
    type: SOLUTIONS_SITE_LINK_CLICK,
    eventData,
  };
}
